import SectionHeader from './SectionHeader';

const values = [
  {
    icon: 'ri-scan-2-line',
    title: '高清画质',
    desc: '全站统一高清原图加载，阅读不糊、体验顺滑。',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '同步更新',
    desc: '热门作品保持高频同步，重要更新不错过。',
  },
  {
    icon: 'ri-verified-badge-line',
    title: '严格甄选',
    desc: '编辑部人工筛选，过滤低质灌水，只推精品。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '阅读友好',
    desc: '多端同步、离线缓存，沉浸式竖屏体验。',
  },
];

const reviews = [
  {
    name: '晓雨',
    tag: '恋爱党',
    text: '追《心动信号时差》快一年了，更新快画质还清楚，追更提醒也超准时，已经安利给整个宿舍。',
  },
  {
    name: '阿泽',
    tag: '悬疑迷',
    text: '《无声证词》的反转真的让我头皮发麻，这里排行榜很靠谱，跟着榜单选从来没踩过雷。',
  },
  {
    name: 'Momo',
    tag: '完结党',
    text: '完结专区太贴心了，可以一口气看到大结局，再也不用苦等连载，周末狂刷三部超级满足。',
  },
];

export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <SectionHeader
          kicker="关于我们"
          title="漫阅韩漫 · 高清韩漫一站式阅读平台"
          desc="我们专注收集与呈现高品质韩国漫画，让每一位读者都能按自己的口味，轻松找到值得追下去的作品。"
        />

        <div className="grid gap-6 lg:grid-cols-5">
          <div className="lg:col-span-2 rounded-2xl bg-background-50 border border-background-200 p-6 md:p-8">
            <h3 className="font-heading text-xl md:text-2xl text-foreground-950">我们的理念</h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              在信息爆炸的时代，真正好的韩漫不该被埋没。漫阅韩漫以「题材分类齐全、更新及时、画质高清」为初心，
              通过严格的内容甄选与实时人气数据，帮助读者用最短的时间找到最对味的作品。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              从恋爱甜宠到奇幻史诗，从校园青春到烧脑悬疑，我们坚持「按口味选漫，不踩雷」的承诺，
              让每一次点击都值得期待。
            </p>
            <ul className="mt-6 space-y-3">
              {values.map((v) => (
                <li key={v.title} className="flex items-start gap-3">
                  <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                    <i className={`${v.icon} text-lg w-5 h-5 flex items-center justify-center`} />
                  </span>
                  <span>
                    <span className="block font-semibold text-sm text-foreground-950">{v.title}</span>
                    <span className="block text-xs text-foreground-500 mt-0.5">{v.desc}</span>
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="rounded-2xl bg-accent-100/70 border border-accent-200 p-5 md:p-6 mb-5">
              <h3 className="font-heading text-lg md:text-xl text-accent-900 flex items-center gap-2">
                <i className="ri-heart-3-fill text-accent-600 w-5 h-5 flex items-center justify-center" />
                读者口碑
              </h3>
              <p className="mt-1 text-xs text-accent-800/70">来自真实读者的真实反馈，是我们持续进步的动力。</p>
            </div>
            <div className="grid gap-5 sm:grid-cols-3">
              {reviews.map((r) => (
                <figure key={r.name} className="rounded-2xl bg-background-50 border border-background-200 p-5 flex flex-col">
                  <i className="ri-double-quotes-l text-primary-400 text-2xl w-6 h-6 flex items-center justify-center" />
                  <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{r.text}</blockquote>
                  <figcaption className="mt-4 flex items-center gap-2.5">
                    <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 text-secondary-800 text-sm font-bold">
                      {r.name.slice(0, 1)}
                    </span>
                    <span>
                      <span className="block text-sm font-semibold text-foreground-950">{r.name}</span>
                      <span className="block text-xs text-foreground-500">{r.tag}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}